import React from 'react';
import { rebondFilter } from '../../../../store/actions';
import { useDispatch, useSelector } from 'react-redux';
import { AppState } from '../../../../store/reducers';
import { Switch } from 'components/atoms/Buttons/Switchs/Switch';
import { DialogContent } from 'components/molecules/Modal/DialogContent';

const RebondProductsCheckbox = () => {
  const rebond = useSelector((state: AppState) => state.productFilter.rebond);
  const dispatch = useDispatch();

  return (
    <DialogContent dialogTitle="Ventes additionnelles">
      <Switch
        defaultValue={rebond ? true : false}
        onClick={() => dispatch(rebondFilter(!rebond))}
      />
    </DialogContent>
  );
};

export default RebondProductsCheckbox;
